const BROWSER_EXTENSION_PROTOCOL = /^(?:chrome|moz|safari-web|safari)-extension:\/\//;

// Browser extensions inject scripts served from *-extension:// URLs. Errors they throw
// bubble to our global handler but aren't ours to fix, so we skip reporting them.
export const isBrowserExtensionError = (filename?: string | null) => BROWSER_EXTENSION_PROTOCOL.test(filename ?? '');
